/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import CloseIcon from '../../../assets/icons/close.svg';
import api from '../../../services/api';
import handleError from '../../../utils/handleError';
import {
  Button,
  Close,
  CloseButton,
  Column,
  Container,
  Content,
  Detail,
  DetailLabel,
  DetailWrapper,
  ImagePreview,
  Input,
  Label,
  ModalHeader,
  Title,
} from './styles';

interface ITag {
  id: string;
  name: string;
  image_url: string;
}

interface Props {
  onClose: () => void;
  editingTag?: ITag;
}

export const ModalRegisterTag: React.FC<Props> = ({ onClose, editingTag }) => {
  const [name, setName] = useState('');
  const [image, setImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (editingTag) {
      setName(editingTag.name);
      setPreviewUrl(editingTag.image_url);
    }
  }, [editingTag]);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;

    const file = e.target.files[0];
    setImage(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const onSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append('name', name);

      if (image) {
        formData.append('image', image);
      }

      if (editingTag) {
        await api.put(`/tags/${editingTag.id}`, formData);
        handleError('Tag atualizada com sucesso!', 'success');
      } else {
        await api.post('/tags', formData);
        handleError('Tag cadastrada com sucesso!', 'success');
      }

      onClose();
    } catch (error: any) {
      handleError(error, 'error');
    }
  };

  return (
    <Container>
      <Content>
        <ModalHeader>
          <Title>{editingTag ? 'Editar Tag' : 'Adicionar Tag'}</Title>
          <CloseButton onClick={onClose}>
            <Close src={CloseIcon} />
          </CloseButton>
        </ModalHeader>
        <Column>
          <DetailWrapper>
            <DetailLabel>Nome</DetailLabel>
            <Detail>
              <Input
                type="text"
                placeholder="Ex.: Tag Exemplo"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setName(e.target.value)
                }
              />
            </Detail>
          </DetailWrapper>

          <DetailWrapper>
            <DetailLabel>Imagem</DetailLabel>
            <Detail>
              <Label htmlFor="tag-image">
                <input
                  type="file"
                  id="tag-image"
                  accept="image/x-png,image/jpeg"
                  onChange={handleImageChange}
                />
                {previewUrl ? (
                  <ImagePreview src={previewUrl} alt="Preview" />
                ) : (
                  'Adicione a imagem da tag'
                )}
              </Label>
            </Detail>
          </DetailWrapper>

          <Button type="button" onClick={onSubmit}>
            {editingTag ? 'Atualizar' : 'Cadastrar'}
          </Button>
        </Column>
      </Content>
    </Container>
  );
};
